export const legalEntities = {
  "legalEntity.russianFrmoOid": "OID הארגון הרפואי (FRMO)",
  "legalEntity.russianFrmoOidHint": "מזהה רשות של ארגון רפואי ברוסיה במרשם FRMO של משרד הבריאות. נדרש רק בעת יצירת מסמך EGISZ.",
  "legalEntity.russianRegionCode": "אזור הכתובת ברוסיה (קוד FNS)",
  "legalEntity.russianOgrn": "מספר רישום ארגון ברוסיה (OGRN)",
  "legalEntity.title": "ישויות משפטיות",
  "legalEntity.subtitle": "מאגר ישויות משפטיות של המרפאה.",
  "legalEntity.create": "הוספת ישות משפטית",
  "legalEntity.open": "פתיחת {name}",
  "legalEntity.actions": "פעולות",
  "legalEntity.legalName": "שם משפטי מדויק",
  "legalEntity.publicName": "שם לציבור",
  "legalEntity.shortName": "שם קצר לממשק",
  "legalEntity.publicNameHint": "לא חובה. מוצג בכותרת ובבחירת הארגון; אם לא הוזן, מוצג השם המשפטי המלא. במסמכים מודפסים חדשים ובמערכת EGISZ נעשה שימוש בשם המשפטי המלא.",
  "legalEntity.kind": "סוג",
  "legalEntity.organization": "ארגון",
  "legalEntity.individual_business": "עסק יחיד",
  "legalEntity.lifecycle": "מצב",
  "legalEntity.active": "פעילה",
  "legalEntity.archived": "בארכיון",
  "legalEntity.current": "הגרסה הנוכחית",
  "legalEntity.historyOption": "{revision} · בתוקף עד {until} · {author}",
  "legalEntity.historyOptionUnattributed": "{revision} · בתוקף עד {until}",
  "legalEntity.archive": "העברה לארכיון",
  "legalEntity.restore": "שחזור",
  "legalEntity.save": "שמירה",
  "legalEntity.saving": "שומר…",
  "legalEntity.loading": "טוען ישויות משפטיות…",
  "legalEntity.empty": "אין ישויות משפטיות",
  "legalEntity.emptyDetail": "אפשר להוסיף ארגון או עסק יחיד למאגר המרפאה.",
  "legalEntity.loadFailed": "לא ניתן לטעון את הישויות המשפטיות.",
  "legalEntity.forbidden": "אין הרשאה לגשת לישויות המשפטיות.",
  "legalEntity.readOnly": "גרסה לקריאה בלבד",
  "legalEntity.failed": "השינוי לא נשמר. הטיוטה נשארה בטופס.",
  "legalEntity.invalid": "יש לבדוק את השדות ותאריכי התוקף. השינוי לא נשמר.",
  "legalEntity.duplicate": "מזהה המס כבר רשום במרפאה, ייתכן שבארכיון.",
  "legalEntity.conflict": "הרשומה השתנתה. יש לטעון ולבדוק את הגרסה העדכנית לפני שמירת הטיוטה.",
  "legalEntity.lifecycleConflict": "מצב הרשומה אינו מאפשר את הפעולה. יש לטעון את הגרסה העדכנית.",
  "legalEntity.reload": "טעינת הגרסה העדכנית",
  "legalEntity.latest": "הפרטים השמורים העדכניים",
  "legalEntity.unsaved": "טיוטת ישות משפטית",
  "legalEntity.unsavedPublicName": "טיוטת השם לציבור",
  "legalEntity.comment": "הערה",
  "legalEntity.validFrom": "בתוקף מתאריך",
  "legalEntity.validTo": "בתוקף עד",
  "legalEntity.taxNone": "ללא מזהה מס",
  "legalEntity.recordedAt": "מועד הרישום"
} as const
